import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 7C20.866 7 24 10.134 24 14L23.9912 14.3604C23.8097 17.9395 20.9395 20.8097 17.3604 20.9912L17 21C13.2549 21 10.1963 18.0589 10.0088 14.3604L10 14C10 10.134 13.134 7 17 7ZM16 14.4141L18.333 16.7471L19.7471 15.333L18 13.5859V11.3359H16V14.4141Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 20H0V18H8V20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 15H0V13H8V15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 10H0V8H8V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 5H0V3H24V5Z"}}]};

const DialogHistoryFilled = Vue.extend<IconProps>({
  name: 'DialogHistoryFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'dialog-history-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DialogHistoryFilled;
